import { SET_UF } from './actionTypes';

import { removeTypename } from '@/utils/parser';
import { UF } from '@/src/types/uf';

export const setUF = (payload: UF) => ({
  type: SET_UF,
  payload: removeTypename(payload),
});
